/**
 * Larissa Portal Theme
 * 
 * This file contains the theme configuration for the Larissa Portal.
 * The primary color is an orange/amber color extracted from the Larissa branding.
 */

export const theme = {
  colors: {
    // Primary orange/amber color from Larissa branding
    primary: {
      hex: '#FF8A3C', // Approximation of the orange/amber color from the image
      oklch: 'oklch(0.75 0.2 60)',
      lighter: '#FFA96B',
      darker: '#E67020',
    },
    // Dark background color
    background: {
      dark: '#121212',
      light: '#FFFFFF',
    },
    // Text colors
    text: {
      dark: '#FFFFFF',
      light: '#121212',
    }
  },
  // Add more theme configurations as needed
};

export default theme;
